<template>
	<div v-loading="loadingEfect" element-loading-text="正在导出，请稍候" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="case-pice"><span class="case-pice-first">报名记录</span> <span class="case-pice-and">/</span> <span
				class="case-pice-second">首页</span></div>
		<div style="display: flex;">
			<div class="commom-input-label-short">学员姓名：</div>
			<div class="common-full-width-style">
				<el-input v-model="searchData.name" clearable class='common-full-width' size='small'
					placeholder="请输入学员姓名"></el-input>
			</div>
			<div class="commom-input-label-short">学员编号：</div>
			<div class="common-full-width-style">
				<el-input v-model="searchData.certificationNo" clearable class='common-full-width' size='small'
					placeholder="请输入学员编号"></el-input>
			</div>
			<div class="commom-input-label-short">报名日期：</div>
			<div class="common-full-width-style">
				<el-date-picker v-model="applicationDate" clearable size='small' type="daterange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" class='common-full-width'>
				</el-date-picker>
			</div>
			<div class="commom-input-label-short">培训类别：</div>
			<div class="common-full-width-style">
				<el-select size='small' class='common-full-width' clearable v-model="searchData.trainingClasses"
					placeholder="请选择">
					<el-option v-for="item in tarinTypeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div style="text-align: right;width:100px;height: 60px;line-height: 60px;">
				<el-button size='small' type="primary" @click='exportTable()' plain>报表导出</el-button>
			</div>
		</div>
		<div style="display: flex;">
			<div class="commom-input-label-short">专业类别：</div>
			<div class="common-full-width-style">
				<el-select size='small' class='common-full-width' v-model="searchData.professionalClasses" clearable
					placeholder="请选择">
					<el-option v-for="(item,index) in majorCategoryList" :key="index" :label="item.codeCname"
						:value="item.codeCode">
					</el-option>
				</el-select>
			</div>
			<div class="commom-input-label-short">考试类别：</div>
			<div class="common-full-width-style">
				<el-select size='small' class='common-full-width' v-model="searchData.trainers" clearable
					placeholder="请选择">
					<el-option v-for="item in trainersList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="commom-input-label-short">支付状态：</div>
			<div class="common-full-width-style">
				<el-select size='small' class='common-full-width' v-model="searchData.payStatus" clearable
					placeholder="请选择">
					<el-option v-for="item in payStatusList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="commom-input-label-short">备注信息:</div>
			<div class="common-full-width-style">
				<el-input v-model="searchData.marks" clearable class='common-full-width' size='small'
					placeholder="请输入备注信息"></el-input>
			</div>
		
			<div class="common-full-width-style"></div>
			<div style="text-align: right;width:100px;height: 60px;line-height: 60px;">
				<el-button size='small' style='width:88px' type="primary" @click='search()' plain icon="el-icon-search">
					查询</el-button>
			</div>
		</div>
		<div style="display: flex;">
			<div class="commom-input-label-short">
				<el-button size='small' type="primary" @click='dialogSearchModel = true' plain>更多条件</el-button>
			</div>
		</div>

		<el-table :row-key="getRowKeys" :data="tableData" border style="width: 100%" height=' calc(100vh - 270px)'
			highlight-current-row :row-style="rowClass" :row-class-name="tableRowClassName"
			@selection-change="handleSelectionChange">
			<el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
			<el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" show-overflow-tooltip label="学员姓名" min-width="100">
			</el-table-column>
			<el-table-column show-overflow-tooltip label="证件类型" min-width="150">
				<template slot-scope="scope">
					<span
						v-if="scope.row.degreeData && scope.row.cardTypeData">{{scope.row.cardTypeData.name=="全部"?"":scope.row.cardTypeData.name}}</span>
					<span v-else>身份证</span>
				</template>
			</el-table-column>
			<el-table-column prop="idCard" show-overflow-tooltip label="证件号码" min-width="150">
			</el-table-column>
			<el-table-column prop="certificationNo" show-overflow-tooltip label="学员编号" min-width="150">
			</el-table-column>
			<el-table-column show-overflow-tooltip label="性别" width="60">
				<template slot-scope="scope">
					<span v-if="scope.row.sex == 1">女</span>
					<span v-else>男</span>
				</template>
			</el-table-column>
			<el-table-column prop="certificationNo" show-overflow-tooltip label="学员照片" min-width="150">
				<template slot-scope="scope">
					<div :id='"imgTooles"+scope.$index' @click="preImage(scope.$index)"
						style="text-align: center;cursor: pointer;">
						<img style=" display:inline-block;height: 50px;width:50px;" :data-original='scope.row.personImg'
							:src="scope.row.personImg" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="education" show-overflow-tooltip label="学历" min-width="100">
				<template slot-scope="scope">
					<span
						v-if="scope.row.educationData">{{scope.row.educationData.name=='全部'?'':scope.row.educationData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="education" show-overflow-tooltip label="学位" min-width="100">
				<template slot-scope="scope">
					<span
						v-if="scope.row.degreeData">{{scope.row.degreeData.name=='全部'?'':scope.row.degreeData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="支付状态" min-width="150">
				<template slot-scope="scope">
					<span v-if='scope.row.payStatus == 1'>已支付</span>
					<span v-else>待支付</span>
				</template>
			</el-table-column>
			<el-table-column prop="phone" show-overflow-tooltip label="手机号码" min-width="150">
			</el-table-column>
			<el-table-column prop="birthday" show-overflow-tooltip label="出生日期" min-width="150">
			</el-table-column>
			<el-table-column prop="nation" show-overflow-tooltip label="民族" min-width="150">
				<template slot-scope="scope">
					<span
						v-if="scope.row.nationData">{{scope.row.nationData.name == '全部'?'':scope.row.nationData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="technicalPosition" show-overflow-tooltip label="专业技术职务" min-width="150">
				<template slot-scope="scope">
					<span
						v-if="scope.row.technicalData">{{scope.row.technicalData.name == '全部'?'':scope.row.technicalData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="homeAddress" show-overflow-tooltip label="通讯地址" min-width="150">
			</el-table-column>
			<el-table-column prop="graduateSchool" show-overflow-tooltip label="毕业院校" min-width="150">
			</el-table-column>
			<el-table-column prop="graduationDate" show-overflow-tooltip label="毕业时间" min-width="150">
			</el-table-column>
			<el-table-column prop="trainingClasses" show-overflow-tooltip label="培训类别" min-width="100">
				<template slot-scope="scope">
					<span v-if='scope.row.trainingClasses == 1'>初次培训</span>
					<span v-if='scope.row.trainingClasses == 2'>继续教育</span>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="专业类别" min-width="150">
				<template slot-scope="scope">
					<span
						v-if="scope.row.professionalData">{{scope.row.professionalData.codeCname == '全部'?'':scope.row.professionalData.codeCname}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="trainers" show-overflow-tooltip label="考试类别" min-width="150">
				<template slot-scope="scope" min-width="100">
					<span v-if='scope.row.trainers == 1'>负责人</span>
					<span v-if='scope.row.trainers == 2'>安全管理人员</span>
					<span v-if='scope.row.trainers == 3'>动态监控</span>
					<span v-if='scope.row.trainers == 4'>其他</span>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="考试科目" min-width="150">
				<template slot-scope="scope">
					<span
						v-if="scope.row.examSubjectData">{{scope.row.examSubjectData.name == '全部'?'':scope.row.examSubjectData.name}}</span>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="累计从事道路运输行业年限" prop="yearsOfWorking" min-width="200">
			</el-table-column>
			<el-table-column prop="companyName" show-overflow-tooltip label="单位名称" min-width="250">
			</el-table-column>
			<el-table-column show-overflow-tooltip label="状态" min-width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.applicationStatus == 0">已取消</span>
					<span v-if="scope.row.applicationStatus == 1">未审核</span>
					<span v-if="scope.row.applicationStatus == 2">审核通过</span>
					<span v-if="scope.row.applicationStatus == 3">审核驳回</span>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="是否拥有安全证书" min-width="150">
				<template slot-scope="scope">
					<span v-if="scope.row.safetyStatus == 1">是</span>
					<span v-else>否</span>
				</template>
			</el-table-column>
			<el-table-column prop="marks" show-overflow-tooltip label="备注" min-width="200">
			</el-table-column>
			<el-table-column show-overflow-tooltip prop='rejectReason' label="驳回原因" min-width="150">
			</el-table-column>
			<el-table-column prop="applicationDate" show-overflow-tooltip label="报名日期" min-width="120">
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="450">
				<template slot-scope="scope">
					<el-button size='mini' type="primary"
						v-if='scope.row.applicationStatus == 0 || scope.row.applicationStatus == 1'
						@click='examineSign("pass",scope.row)' plain>通过</el-button>
					<el-button size='mini' type="danger"
						v-if='scope.row.applicationStatus == 0 ||scope.row.applicationStatus == 1'
						@click='examineSign("turn",scope.row)' plain>驳回</el-button>
					<el-button size='mini' type="primary" @click='editSign(scope.row)' plain>修改</el-button>
						<!-- <el-button size='mini' type="primary"
						v-if='scope.row.applicationStatus == 0 ||scope.row.applicationStatus == 1 ||scope.row.applicationStatus == 3'
						@click='editSign(scope.row)' plain>修改</el-button> -->
					<el-button size='mini' type="info" @click='examineSign("look",scope.row,scope.$index)' plain>查看
					</el-button>
					<el-button size='mini' v-if="scope.row.payStatus != 1" type="danger"
						@click='deleteSign(scope.row,scope.$index)' plain>删除
					</el-button>
					<el-button size='mini' type="danger"
						@click='remarkSign(scope.row,scope.$index)' plain>备注
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-block">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10,20,50,100,500,1000]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
			</el-pagination>
		</div>
		<el-dialog title="驳回原因" :visible.sync="dialogBillVisible" v-if='dialogBillVisible' width='40%'>
			<div style="display: flex;">
				<!--<div class='bill-left-block'>
					驳回原因：
				</div>-->
				<div style="flex: 1;">
					<el-input v-model="rejectReason" type='textarea' row='3' clearable class='common-full-width'
						size='small' placeholder="请输入驳回原因"></el-input>
				</div>
			</div>
			<div style="text-align:center;height: 50px;line-height: 50px;">
				<el-button size='small' type="primary" @click='defineSave()' plain>确定</el-button>
				<el-button size='small' type="info" @click='dialogBillVisible = false' plain>取消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="查询条件" :visible.sync="dialogSearchModel" v-if='dialogSearchModel' width='80%'>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">安全证书：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.safetyStatus" clearable
							placeholder="请选择">
							<el-option v-for="item in safetyList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">证件类型：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.idType" clearable
							placeholder="请选择">
							<el-option v-for="item in cardTypeList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">证件号：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.idCard" clearable class='common-full-width' size='small'
							placeholder="请输入证件号"></el-input>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">性别：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.sex" clearable
							placeholder="请选择性别">
							<el-option v-for="item in sexList" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">手机号：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.phone" clearable class='common-full-width' size='small'
							placeholder="请输入手机号"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">出生日期：</div>
					<div class="common-full-width-style">
						<el-date-picker size='small' style="width: 100%;" v-model="searchData.birthday" type="date"
							placeholder="选择出生日期"></el-date-picker>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">民族：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.nation" clearable
							placeholder="请选择">
							<el-option v-for="item in nationList" :key="item.cc" :label="item.name" :value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<!-- <div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="font-size: 13px !important;">专业技术职务</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.technicalPosition"
							clearable placeholder="请选择专业技术职务">
							<el-option v-for="item in technicalList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div> -->
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">通讯地址：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.homeAddress" clearable class='common-full-width' size='small'
							placeholder="请输入通讯地址"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">学历：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.education" clearable
							placeholder="请选择学历">
							<el-option v-for="item in educationList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</div>
			<!-- <div style="display: flex;"> -->
				<!-- <div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">毕业院校：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.graduateSchool" clearable class='common-full-width' size='small'
							placeholder="请输入毕业院校"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">毕业时间：</div>
					<div class="common-full-width-style">
						<el-date-picker size='small' style="width: 100%;" v-model="searchData.graduationDate"
							type="date" placeholder="选择毕业时间"></el-date-picker>
					</div>
				</div> -->
				
			<!-- </div> -->
			<!-- <div style="display: flex;"> -->
				<!-- <div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">学位：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.degree" clearable
							placeholder="请选择学位">
							<el-option v-for="item in degreeList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">考试科目：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.examSubject" clearable
							placeholder="请选择考试科目">
							<el-option v-for="item in examSubjectList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div> -->
				
			<!-- </div> -->
			<div style="display: flex;">
				<div style="flex: 1;display: flex;">
					<div class="commom-input-label-short">状态：</div>
					<div class="common-full-width-style">
						<el-select size='small' class='common-full-width' v-model="searchData.applicationStatus"
							clearable placeholder="请选择">
							<el-option v-for="item in stateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short">单位名称：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.companyName" clearable class='common-full-width' size='small'
							placeholder="请输入单位名称"></el-input>
					</div>
				</div>
			</div>
			<div style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="width: 200px;">累计从事道路运输行业年限：</div>
					<div class="common-full-width-style">
						<el-input v-model="searchData.yearsOfWorking" clearable class='common-full-width' size='small'
							placeholder="请输入累计从事道路运输行业年限"></el-input>
					</div>
				</div>
				<div style="display: flex;flex: 1;">
					<div class="commom-input-label-short" style="width: 200px;">工商（法人）注册地筛选：</div>
					<div class="common-full-width-style">
						<el-cascader @change="changegeData(bigName)" style="width:100%" size='small'
							placeholder="请选择工商（法人）注册地筛选" v-model="bigName" :options="mapData" :props="{value:'label'}">
						</el-cascader>
					</div>
				</div>
			</div>

			<div style="text-align:center;height: 50px;line-height: 50px;">
				<el-button size='small' type="primary" @click='search()' plain icon="el-icon-search">查询</el-button>
				<el-button size='small' type="info" @click='dialogSearchModel = false' plain icon='el-icon-refresh'>取消
				</el-button>
			</div>
		</el-dialog>
     <!-- 备注-->
	 <el-dialog
      title="备注信息编辑"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :before-close="handleClose"
      class="upload-dialog"
    >
	<div style="display: flex;">
   <div style="flex: 1;">
		<el-input v-model="mark" type='textarea' row='3' clearable class='common-full-width'
				size='small' placeholder="请输入备注"></el-input>
			</div>
		</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="logisticeSave()"
          >保 存</el-button
        >
      </span>
    </el-dialog>


	</div>
</template>

<script>
	import axios from 'axios';
	import Viewer from 'viewerjs';
	import {
		applicationFormList,
		examOrBack,
		majorTypeList,
		deleteStudentBill,
		updateMark
	} from '../../api/main'
	import map from '@/common/js/map.js'
	export default {
		data() {
			return {
				mapData: map,
				loadingEfect: false,
				dialogVisible:false,// 备注弹窗
		
				applicationDate: '',
				searchData: {
					applicationDateStart: '',
					applicationDateEnd: '',
					applicationStatus: '',
					certificationNo: '',
					name: '',
					professionalClasses: '',
					trainers: '',
					trainingClasses: '',
					safetyStatus: '',
					degree: '', //学位
					major: '', //专业
					graduationDate: '', //毕业时间
					graduateSchool: '', //毕业院校
					homeAddress: '', //通讯地址
					email: '', //邮箱
					technicalPosition: '', //专业技术职务
					nation: '', //民族
					idType: '', //证件类型
					birthday: '', //出生日期
					registrationPlace: '', //工商（法人）注册
					postcode: '', //邮编
					recipientsPhone: '', //联系电话
					recipients: '', //收件人
					mailingAddress: '', //证书邮寄地址
					employedDate: '', //受雇日期
					yearsOfWorking: '', //累计从事道路运输工作年限
					companyContacts: '', //企业联系人
					companyContactsPhone: '', //企业联系人电话
					examSubject: '', //考试科目
					idCard: '',
					sex: '',
					education: '',
					companyName: '',
					payStatus: '',
					mark:"",//备注

				},

				options: [{
					label: '未更正',
					value: '未更正'
				}, {
					label: '已更正',
					value: '已更正'
				}],
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				totalNumber: 0,
				safetyList: [{
					label: '全部',
					value: ''
				}, {
					label: '是',
					value: '1'
				}, {
					label: '否',
					value: '0'
				}],
				payStatusList: [{
					label: '全部',
					value: ''
				}, {
					label: '已支付',
					value: '1'
				}, {
					label: '待支付',
					value: '0'
				}],
				tarinTypeList: [{
					label: '全部',
					value: ''
				}, {
					label: '初次培训',
					value: '1'
				}, {
					label: '继续教育',
					value: '2'
				}],
				majorCategoryList: [],
				trainersList: [{
					label: '全部',
					value: ''
				}, {
					label: '负责人',
					value: '1'
				}, {
					label: '安全管理人员',
					value: "2"
				}, {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}],
				stateList: [{
					label: '全部',
					value: ''
				}, {
					label: '未审核',
					value: "1",
				}, {
					label: '已取消',
					value: "0",
				}, {
					label: '审核通过',
					value: "2",
				}, {
					label: '审核驳回',
					value: "3",
				}],
				stateList: [{
					label: '全部',
					value: ''
				}, {
					label: '未审核',
					value: "1",
				}, {
					label: '已取消',
					value: "0",
				}, {
					label: '审核通过',
					value: "2",
				}, {
					label: '审核驳回',
					value: "3",
				}],
				dialogBillVisible: false,
				nowId: "",
				rejectReason: '',
				currentRow: '',
				selectedIndex: '',
				nowSelectDataList: [],
				dialogSearchModel: false,
				provinceName: '',
				cityName: '',
				countyName: '',
				bigName: '',
				mark:"",//备注
			}
		},
		computed: {
			cardTypeList() {
				let cardTypeList = JSON.parse(sessionStorage.getItem('cardTypeList'));
				return cardTypeList;
			},
			sexList() {
				let sexList = [{
					name: '全部',
					code: ''
				}, {
					name: '男',
					code: 0
				}, {
					name: '女',
					code: 1
				}];
				return sexList;
			},
			nationList() {
				let nationList = JSON.parse(sessionStorage.getItem('nationList'));
				return nationList;
			},
			technicalList() {
				let technicalList = JSON.parse(sessionStorage.getItem('technicalList'));
				return technicalList;
			},
			educationList() {
				let educationList = JSON.parse(sessionStorage.getItem('educationList'));
				return educationList;
			},
			degreeList() {
				let degreeList = JSON.parse(sessionStorage.getItem('degreeList'));
				return degreeList;
			},
			examSubjectList() {
				let examSubjectList = JSON.parse(sessionStorage.getItem('examSubjectList'));
				return examSubjectList;
			},
		},
		mounted() {
			if (sessionStorage.getItem('signSelect')) {
				this.searchData = JSON.parse(sessionStorage.getItem('signSelect'))
			}

			this.getSignUpList();
			this.getMajorDataList();
		},
		activated() {
			if (sessionStorage.getItem('signSelect')) {
				this.searchData = JSON.parse(sessionStorage.getItem('signSelect'))
			}

			this.getSignUpList();
			this.getMajorDataList();
		},
		methods: {
			changegeData(value) {
				console.log(value)
				if (value.length == 2) {
					this.provinceName = value[0];
					this.cityName = value[0];
					this.countyName = value[1];
				} else {
					this.provinceName = value[0];
					this.cityName = value[1];
					this.countyName = value[2];
				}
			},
			getRowKeys(row) {
				return row.applicationFormId;
			},
			handleSelectionChange(data) {
				console.log(data)
				this.nowSelectDataList = data;
			},
			preImage(index) {
				const ViewerDom = document.getElementById('imgTooles' + index);
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			rowClass({
				row,
				rowIndex
			}) {
				if ((this.selectedIndex) === rowIndex) {
					return {
						"border": "solid 1px #3dffef",
						"background-color": "rgb(185, 221, 249)"
					}
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				row.index = rowIndex;
			},
			defineSave() {
				if (this.rejectReason == '') {
					this.$message.error('请输入驳回原因！');
					return;
				}
				this.$confirm('确定驳回所选项吗？', '审核驳回', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					examOrBack({
						applicationFormId: this.nowId,
						applicationStatus: 3,
						rejectReason: this.rejectReason
					}).then(res => {
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '驳回成功'
							});
							this.dialogBillVisible = false;
							this.search();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消驳回'
					});
				});
			},
			deleteSign(row, index) {
				this.$confirm('确定删除所选项吗？', '删除数据', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteStudentBill({
						applicationFormId: row.applicationFormId
					}).then(res => {
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.search();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消驳回'
					// });
				});
			},
			exportTable() {
				var dateStr = '';
				if (this.$util.getNowDate(this.applicationDate[0])) {
					// var dateStr = this.$util.getNowDate(this.applicationDate[0]) + ',' + this.$util.getNowDate(
					// 	this.applicationDate[1]);
					this.searchData.applicationDateStart = this.$util.getNowDate(this.applicationDate[0])
					this.searchData.applicationDateEnd = this.$util.getNowDate(this.applicationDate[1])
				}
				// this.applicationDate = dateStr
				if (this.nowSelectDataList.length == 0) {
					this.$message.error('请选择您想要导出的学员数据');
					return;
				}
				let arrList = [];
				this.loadingEfect = true;
				this.nowSelectDataList.forEach((item) => {
					arrList.push(item.applicationFormId)
				})
				// let arrI
				axios({
					responseType: 'blob',
					url: `${this.$httpUrl}/admin/applicationForm/list/excel`,
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'post',
					data: arrList
				}).then(res => {
					console.log(res)
					const link = document.createElement('a')
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					})
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob)
					link.setAttribute('download', '报名记录列表.xlsx')
					document.body.appendChild(link)
					link.click()
					URL.revokeObjectURL(link.href);
					document.body.removeChild(link)
					this.loadingEfect = false;
					this.$message.success('导出成功！')
				})
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			getMajorDataList() {
				majorTypeList({
					current: 1,
					pageSize: 30,
					professionalName: ''
				}).then(res => {
					this.majorCategoryList = res.data.records;
					this.majorCategoryList.unshift({
						codeCname: '全部',
						codeCode: ''
					})
				})
			},
			getSignUpList() {
				var dateStr = '';
				this.searchData.provinceName = this.provinceName;
				this.searchData.cityName = this.cityName;
				this.searchData.countyName = this.countyName;
				if (this.$util.getNowDate(this.applicationDate[0])) {
					// var dateStr = this.$util.getNowDate(this.searchData.applicationDate[0]) + ',' + this.$util.getNowDate(
					// 	this.searchData.applicationDate[1]);
					this.searchData.applicationDateStart = this.$util.getNowDate(this.applicationDate[0])
					this.searchData.applicationDateEnd = this.$util.getNowDate(this.applicationDate[1])
				}
				this.searchData.pageSize = this.pageSize;
				this.searchData.current = this.currentPage;
				applicationFormList(this.searchData).then(res => {
					this.tableData = res.data.records;
					this.totalNumber = parseInt(res.data.total);
					this.tableData.forEach((item) => {
						item.degreeData = this.degreeList.find((value) => value.code == item
							.degree);
						item.cardTypeData = this.cardTypeList.find((value) => value.code == item.idType);
						item.nationData = this.nationList.find((value) => value.code == item.nation);
						item.technicalData = this.technicalList.find((value) => value.code == item
							.technicalPosition);
						item.professionalData = this.majorCategoryList.find((value) => value.codeCode ==
							item.professionalClasses);
						item.examSubjectData = this.examSubjectList.find((value) => value.code == item
							.examSubject);
						item.educationData = this.educationList.find((value) => value.code == item
							.education);
					})
					console.log(this.tableData)
		
				})
			},
			search() {
				this.currentPage = 1;
				this.getSignUpList();
				this.dialogSearchModel = false;
			},
			handleSizeChange(data) {
				this.pageSize = data;
				this.getSignUpList();
			},
			handleCurrentChange(data) {
				this.currentPage = data;
				this.getSignUpList();
			},
			checkMember(row) {
				this.$confirm('确定更正所选项吗？', '企业更正', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '更正成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消更正'
					});
				});
			},
			lookMemberInfo(row) {
				this.$store.state.signUpRecordId = row.id;
				this.$router.push('/SignUpDetail')
			},
			editSign(row) {
				sessionStorage.setItem('signSelect', JSON.stringify(this.searchData))
				this.$store.state.signUpRecordId = row.applicationFormId;
				this.$router.push('/SignUpEdit');
			},
			examineSign(text, row, indexi) {
				if (text == 'pass') {
					this.$confirm('确定通过所选项吗？', '审核通过', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						examOrBack({
							applicationFormId: row.applicationFormId,
							applicationStatus: 2
						}).then(res => {
							if (res.code == 1) {
								this.$message({
									type: 'success',
									message: '审核成功'
								});
								this.search();
							} else {
								this.$message({
									type: 'error',
									message: res.msg
								});
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消审核'
						});
					});
				} else if (text == 'turn') {
					this.dialogBillVisible = true;
					this.nowId = row.applicationFormId;
				} else {
					sessionStorage.setItem('signSelect', JSON.stringify(this.searchData))
					this.$store.state.signUpRecordId = row.applicationFormId;
					this.selectedIndex = indexi;
					sessionStorage.setItem('rowindex', indexi)
					this.$router.push('/SignUpDetail')
				}
			},
			// 备注
			remarkSign(vl){
				this.dialogVisible =  true;
				this.nowId = vl.applicationFormId;
			},
			// 保存备注
			logisticeSave(){
				updateMark({
						applicationFormId: this.nowId,
						marks: this.mark,
					}).then(res => {
						if (res.code == 1) {
							this.dialogVisible = false;
							this.search();
							this.$message({
									type: 'success',
									message: '提交成功'
								});
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
						this.mark = "";
					})
			},
			  // 关闭上传图片弹窗
			  handleClose() {
				this.mark = "";
               this.dialogVisible = false;
              },
		}
	}
</script>

<style lang="less">
.upload-dialog {
  .el-dialog__header {
    .center-title .el-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    background: white;
    .el-dialog__title {
      color: black;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: black;
    }
  }
}

</style>
